import { useManagement } from '../store'
import {
  getImpersonatorId,
  getUserId,
} from '../store/management/managementSelectors'

const FRONT_DEVS_IDS = [
  8614689, 1408, 7435594, 6970073, 8417501, 10276448, 10954696, 3635572,
]

export function useIsImpersonatorAndSuperAdmin() {
  const impersonatorId = useManagement(getImpersonatorId)
  const userId = useManagement(getUserId)

  return impersonatorId
    ? FRONT_DEVS_IDS.includes(impersonatorId)
    : userId
      ? // NOTE: if a user on his own page
        FRONT_DEVS_IDS.includes(userId)
      : false
}
